import { createThemeAssets, imageUrl } from '../createThemeAssets'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

export default {
    name: 'purple',
    label: 'Purple',
    assets,
    cssVars: {
        '--theme-root-bg': '#19041f',
        '--theme-page-bg': imageUrl(assets.home.pageBg),
        '--theme-page-bg-size': 'cover, cover, cover',
        '--theme-page-bg-position': 'center top, center top, center top',
        '--theme-header-bg': 'rgba(0, 0, 0, .3)',
        '--theme-header-control-bg': '#1E0032',
        '--theme-header-control-border': '#7606AF',
        '--theme-header-control-border-gradient': 'linear-gradient(180deg, rgba(213, 161, 216, .45), rgba(118, 6, 175, 1))',
        '--theme-header-accent-bg': 'linear-gradient(180deg, #A82CBE 0%, #5D0372 100%)',
        '--theme-surface-bg': 'rgba(41, 6, 71, .4)',
        '--theme-surface-border': '#57118C',
        '--theme-soft-text': '#FFC7F9',
        '--theme-bright-text': '#fffafe',
        '--theme-input-bg': '#32064F',
        '--theme-input-border': '#981FCE',
        '--theme-input-focus-bg': '#39005C',
        '--theme-input-focus-border': '#E017F9',
        '--theme-input-focus-border-rgb': '224, 23, 249',
        '--theme-input-placeholder': 'rgba(255, 199, 249, .66)',
        '--theme-list-bg': 'rgba(0, 0, 0, .2)',
        '--theme-list-header-bg': 'rgba(64, 10, 73, .8)',
        '--theme-list-row-border': 'rgba(255, 255, 255, .22)',
        '--theme-active-bg': 'linear-gradient(90deg, #FC5DF9 0%, #8A0FB3 100%)',
        '--theme-active-text': '#ffffff',
        '--theme-gold-bg': 'linear-gradient(180deg, #FFD426 0%, #FF7E13 100%)',
        '--theme-gold-text': '#290000',
        '--theme-banner-bg': imageUrl(assets.home.bannerBg),
        '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
        '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
        '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
        '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
        '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
        '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
        '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
        '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
        '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
        '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
        '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
        '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
        '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
        '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
        '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
        '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
        '--theme-home-classify-fixed-bg': 'linear-gradient(180deg, rgba(255, 226, 248, .04) 0%, rgba(255, 226, 248, 0) .16rem), linear-gradient(180deg, rgba(89, 29, 86, .98) 0%, rgba(48, 13, 58, .98) 100%)',
        '--theme-home-classify-item-bg': 'radial-gradient(circle at 12% 0, rgba(224, 82, 210, .2) 0, rgba(224, 82, 210, 0) 26%), linear-gradient(180deg, rgba(255, 219, 248, .1) 0%, rgba(255, 219, 248, 0) .1rem), linear-gradient(180deg, rgba(160, 78, 150, .96) 0%, rgba(105, 47, 99, .99) 100%)',
        '--theme-home-classify-icon-bg': '#7a2d73',
        '--theme-home-classify-nav-bg': 'linear-gradient(180deg, rgba(255, 219, 248, .12) 0%, rgba(255, 219, 248, 0) .12rem), linear-gradient(180deg, rgba(156, 77, 146, .96) 0%, rgba(99, 42, 94, .99) 100%)',
        '--theme-home-classify-nav-border': 'rgba(255, 219, 248, .18)',
        '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(255, 238, 250, .08), 0 .04rem .1rem rgba(20, 4, 24, .16)',
        '--theme-home-banner-panel-bg': 'linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .02), rgba(51, 13, 90, .5))',
        '--theme-home-section-top-bg': 'linear-gradient(180deg, rgba(66, 6, 82, .6) 0%, rgba(66, 6, 82, 0) 100%)',
        '--theme-home-notice-line-bg': 'linear-gradient(180deg, #D306E6, #FDE7FF, #D406E7)',
        '--theme-home-notice-item-bg': 'linear-gradient(-90deg, rgba(48, 6, 53, 0) 0%, rgba(48, 6, 53, .8) 100%)',
        '--theme-home-notice-icon-filter': 'brightness(0) saturate(100%) invert(78%) sepia(28%) saturate(1944%) hue-rotate(284deg) brightness(102%) contrast(101%) drop-shadow(0 .02rem .08rem rgba(213, 161, 216, .24))',
        '--theme-game-placeholder-surface': 'linear-gradient(180deg, rgba(148, 70, 139, .94) 0%, rgba(90, 38, 84, .99) 100%)',
        '--theme-game-placeholder-skeleton': 'linear-gradient(110deg, rgba(255, 219, 248, 0) 30%, rgba(224, 82, 210, .22) 50%, rgba(255, 219, 248, 0) 70%), linear-gradient(180deg, rgba(79, 31, 91, .48) 0%, rgba(30, 0, 50, .92) 100%)',
        '--theme-game-placeholder-fallback': 'radial-gradient(circle at 50% 18%, rgba(224, 82, 210, .18) 0%, rgba(224, 82, 210, 0) 36%), linear-gradient(180deg, rgba(79, 31, 91, .92) 0%, rgba(30, 0, 50, .99) 100%)',
        '--theme-game-placeholder-border': 'rgba(255, 219, 248, .14)',
        '--theme-game-title-bg': 'linear-gradient(180deg, rgba(90, 38, 84, .72) 0%, rgba(30, 0, 50, .9) 100%)',
        '--theme-game-title-text': '#FFC7F9',
        '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
        '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
        '--theme-footer-title-text': '#C899E7',
        '--theme-footer-body-text': '#F9DCFC',
        '--theme-footer-muted-text': 'rgba(251, 208, 255, .88)',
        '--theme-footer-copyright-text': '#ffffff',
        '--theme-footer-menu-title-bg': 'linear-gradient(90deg, rgba(64, 10, 73, .9) 0%, rgba(15, 5, 53, .08) 100%)',
        '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-footer-menu-list-bg': 'linear-gradient(90deg, rgba(34, 4, 56, .58) 0%, rgba(15, 5, 53, .12) 100%)',
        '--theme-footer-menu-link-text': '#F9DCFC',
        '--theme-home-banner-html-text': '#F6A4E3',
        '--theme-share-bg-top': imageUrl(assets.share.bgTop),
        '--theme-share-bg': imageUrl(assets.share.shareBg),
        '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
        '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
        '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
        '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
        '--theme-event-top-bg': imageUrl(assets.event.topBg),
        '--theme-event-top-right': imageUrl(assets.event.topRight),
        '--theme-event-detail-text': '#F6A4E3',
        '--theme-event-card-bg': 'var(--theme-popup-panel-bg)',
        '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
        '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
        '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
        '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
        '--theme-signin-accent-text': '#FF8400',
        '--theme-signin-accent-border': '#E524FF',
        '--theme-signin-progress-line': '#5C17AA',
        '--theme-signin-disabled-btn-bg': '#6F5175',
        '--theme-signin-disabled-btn-text': '#ffffff',
        '--theme-signin-day-bg': '#5C1179',
        '--theme-signin-day-border': '#F3B1FF',
        '--theme-signin-unlocked-bg': 'linear-gradient(180deg, #A552B0 0%, #915C98 99.29%)',
        '--theme-signin-secondary-amount-text': '#BF630E',
        '--theme-signin-nav-btn-bg': 'rgba(255, 255, 255, .2)',
        '--theme-signin-active-icon-shadow': '0px 2px 4px 0px rgba(205, 5, 5, .7)',
        '--theme-frame-line-vertical': 'linear-gradient(to bottom, transparent 0%, #56257B 10%, #D900FF 50%, #56257B 85%, transparent 100%)',
        '--theme-frame-line-horizontal': 'linear-gradient(to right, transparent 0%, #5B57AC 15%, #D900FF 50%, #5B57AC 85%, transparent 100%)',
        '--theme-tabbar-shell-bg': '#6A0890',
        '--theme-tabbar-text': 'rgba(255, 255, 255, .65)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-float-bg': 'linear-gradient(180deg, rgba(50, 6, 79, .96) 0%, rgba(109, 44, 97, .98) 100%)',
        '--theme-tabbar-divider': 'rgba(255, 239, 248, .18)',
        '--theme-tabbar-active-bg': [
            imageUrl(assets.tabbar.activeBorders[0]),
            imageUrl(assets.tabbar.activeBorders[1]),
            imageUrl(assets.tabbar.activeBorders[2]),
            imageUrl(assets.tabbar.activeBorders[3]),
            'linear-gradient(135deg, #FC5DF9, #FC5DF9)'
        ].join(','),
        '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
        '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
        '--theme-popup-bg': 'linear-gradient(180deg, #1F042F 0%, #32064F 100%)',
        '--theme-popup-overlay-bg': 'rgba(4, 14, 32, .72)',
        '--theme-popup-close-bg': '#29093E',
        '--theme-popup-close-border': '#3B1C5B',
        '--theme-popup-panel-bg': 'rgba(41, 6, 71, .4)',
        '--theme-popup-panel-fill': '#330B56',
        '--theme-popup-panel-border': 'linear-gradient(180deg, rgba(62, 18, 129, .6), rgba(63, 19, 129, .3))',
        '--theme-popup-panel-shadow': 'inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .2), inset -.16rem -.16rem .58rem 0 rgba(255, 255, 255, .2)',
        '--theme-panel-strong-bg': 'linear-gradient(180deg, #6A1886 0%, #561392 100%)',
        '--theme-card-strong-bg': 'linear-gradient(180deg, #4A2263 0%, #1E082F 100%)',
        '--theme-card-strong-border': '#77108F',
        '--theme-popup-tabs-bg': 'rgba(62, 19, 94, .8)',
        '--theme-popup-mask-bg': 'rgba(15, 5, 53, .5)',
        '--theme-popup-box-bg': 'rgba(50, 6, 79, .9)',
        '--theme-popup-box-border': '#7900AC',
        '--theme-popup-box-shadow': 'inset 0 0 .1rem 0 rgba(249, 18, 172, .8)',
        '--theme-popup-amount-text': '#FFCE2D',
        '--theme-sidebar-bg': `${imageUrl(assets.sidebar.sidebarBorder)}, radial-gradient(70.71% 70.71% at 0% 50%, #290541 0%, #1E0032 100%)`,
        '--theme-sidebar-bg-size': '12px auto, 100% 100%',
        '--theme-sidebar-border': '#411649',
        '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
        '--theme-sidebar-item-text': '#C899E7',
        '--theme-sidebar-item-active-bg': 'linear-gradient(-90deg, rgba(43, 5, 61, 0) 0%, #FC5DF9 100%)',
        '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #D306E6, #FDE7FF, #D406E7)',
        '--theme-sidebar-control-bg': '#33094F',
        '--theme-sidebar-control-border': '#6C1D73',
        '--theme-sidebar-service-bg': 'linear-gradient(180deg, #9D2CE8 0%, #33094F 100%)',
        '--theme-sidebar-drawer-mask-bg': 'rgba(108, 40, 98, .58)'
    }
}
